import apiFetch from '@wordpress/api-fetch';
import { toast } from 'sonner-vanilla';
import { openModal } from '../modal/modal';

interface PasswordResponse {
	message: string;
}

export function initPasswordChange(): void {
	document.addEventListener('click', (e) => {
		const btn = (e.target as HTMLElement).closest<HTMLButtonElement>(
			'[data-modal="ac-password-change"]',
		);
		if (!btn) return;

		const template = document.getElementById(
			'ac-password-change',
		) as HTMLTemplateElement | null;
		if (!template) return;

		const content = template.content.firstElementChild!.cloneNode(
			true,
		) as HTMLElement;

		const modal = openModal({
			content,
			title: btn.dataset.title || 'Change password',
			size: (btn.dataset.size as 'sm' | 'md') || 'sm',
		});

		const form = modal.bodyEl.querySelector('form');
		if (!form) return;

		form.addEventListener('submit', async (ev) => {
			ev.preventDefault();

			const currentPassword = (
				form.querySelector('[name="current_password"]') as HTMLInputElement
			).value;
			const newPassword = (
				form.querySelector('[name="new_password"]') as HTMLInputElement
			).value;
			const confirmPassword = (
				form.querySelector('[name="_password"]') as HTMLInputElement
			).value;

			if (!currentPassword) {
				toast.error('Please enter your current password.');
				return;
			}
			if (newPassword.length < 8) {
				toast.error('New password must be at least 8 characters.');
				return;
			}
			if (newPassword !== confirmPassword) {
				toast.error('Passwords do not match.');
				return;
			}

			const submitBtn =
				form.querySelector<HTMLButtonElement>('[type="submit"]');
			if (submitBtn) {
				submitBtn.disabled = true;
				submitBtn.classList.add('ac-btn--loading');
			}

			try {
				const res = await apiFetch<PasswordResponse>({
					path: 'allcoach/v1/client/change-password',
					method: 'POST',
					data: {
						current_password: currentPassword,
						new_password: newPassword,
						confirm_password: confirmPassword,
					},
				});

				toast.success(res.message || 'Password updated successfully.');
				modal.close();
			} catch (err) {
				const message =
					(err as { message?: string })?.message || 'Something went wrong.';
				toast.error(message);
				if (submitBtn) {
					submitBtn.disabled = false;
					submitBtn.classList.remove('ac-btn--loading');
				}
			}
		});
	});
}
